import React from 'react'
import { useTranslation } from 'react-i18next'

import { getCurrencyFormat } from '../../utils/utils'

import './upsell-selector.styles.scss'

const UpsellSelector = ({ upsell, changeHandler, ...otherProps }) => {
  const { variants, translationKeys } = upsell
  const { t } = useTranslation('updatedBAB')

  const hasMoreThanOneVariant = upsell.variants.length > 1
  const firstVariantData = variants[0]

  const upgradePrice = upsell.variants[0].upgradeData.price
  const upsellPrice = upsell.variants[0].upsellData.price

  return (
    <div
      className='upsell-selector'
      data-upgrade-sku={firstVariantData.upgradeData.sku}
      data-upsell-sku={firstVariantData.upsellData.sku}
    >
      <div className='upsell-infos'>
        <div className='upsell-image-container'>
          <img
            src={`${firstVariantData.imageSource}?width=100`}
            alt={t(firstVariantData.translationKeys.imageAlt)}
            width='100'
            height='92'
            loading='lazy'
          />
        </div>
        <div
          className={
            hasMoreThanOneVariant
              ? 'upsell-data-container variants'
              : 'upsell-data-container'
          }
        >
          <p className='upsell-title'>{t(translationKeys.name)}</p>
          {hasMoreThanOneVariant && (
            <select className='upsell-options' onChange={changeHandler}>
              {variants.map((variant) => (
                <option
                  data-upgrade-sku={variant.upgradeData.sku}
                  data-upsell-sku={variant.upsellData.sku}
                >
                  {t(variant.translationKeys.optionName)}
                </option>
              ))}
            </select>
          )}
          <p className='upsell-description'>{t(translationKeys.description)}</p>
        </div>
      </div>
      <div className='upsell-inputs'>
        <div className='upsell-subscription' data-checked={null}>
          <p className='upsell-text upsell-text-bold'>
            {t('upsell.subscription.text')}
            {' - '}
            {upsellPrice > upgradePrice && (<span className='upsell-compare'>{getCurrencyFormat(upsell.variants[0].upsellData.price)}</span>)}
            <span className='upsell-price'> {getCurrencyFormat(upsell.variants[0].upgradeData.price)}</span>
          </p>
          <input className='upsell-checkbox' type='checkbox' />
        </div>
        <p className='upsell-tooltip'>
          {t('upsell.subscription.tooltip', {
            product: t(translationKeys.tooltipText)
          })}
        </p>
        <div className='upsell-one-shot' data-checked={null}>
          <p className='upsell-text'>
            {t('upsell.oneShot.text')}
            {' - '}
            <span className='upsell-price'>{getCurrencyFormat(upsell.variants[0].upsellData.price)}</span>
          </p>
          <input className='upsell-checkbox' type='checkbox' />
        </div>
        <p className='upsell-tooltip'>
          {t('upsell.oneShot.tooltip', {
            product: t(translationKeys.tooltipText)
          })}
        </p>
      </div>
    </div>
  )
}

export default UpsellSelector
